import axios from 'axios'

const setupAxiosInterceptors = () => {
  // Request Interceptor
  axios.interceptors.request.use(
    (config) => {
      const token = JSON.parse(localStorage.getItem('apiToken'))
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  // Response Interceptor
  axios.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        // Clear local storage and redirect to login
        localStorage.clear()
        window.location.href = '/login'
      }
      return Promise.reject(error)
    },
  )
}

export default setupAxiosInterceptors
